import { useLocalStorage } from "@vueuse/core"
import { defineStore } from "pinia"

const chartWidgetId = useLocalStorage<string | null>("playground-chartWidgetId", null)
const history = useLocalStorage<string[]>("playground-history", [])

interface State {
  dialog: boolean
  chartWidgetId: string | null
  formula: string | null
  history: string[]
}

export type sources = "main" | "selection" | "history"

export const usePlaygroundStore = defineStore("playground", {
  state: (): State => ({
    dialog: false,
    chartWidgetId: null,
    formula: null,
    history: []
  }),
  actions: {
    resetState() {
      this.chartWidgetId = null
      this.formula = null
      this.history = []
    },
    resetLocalStorage() {
      chartWidgetId.value = null
    },
    saveState() {
      chartWidgetId.value = this.chartWidgetId
    },
    loadState() {
      this.chartWidgetId = chartWidgetId.value
      this.history = history.value
    },
    addItemToHistory(item: string) {
      // Don't add the same item to history
      if (this.history.length && this.history[0] === item) {
        return
      }

      this.history.unshift(item)

      if (this.history.length > 40) {
        this.history.pop()
      }
    },

    removeItemFromHistory(index: number) {
      if (index > -1) {
        this.history.splice(index, 1)
      }
    }
  },
})
